import { DOCUMENT } from "@angular/common";
import { Component, HostBinding, HostListener, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.scss"],
})
export class LandingComponent implements OnInit {
  shouldHidePrimaryDiv = false;
  windowScrolled: boolean;
  showSpinner = true;
  @HostBinding('attr.data-aos')
  dataAosAttribute: string;
  constructor(private router: Router, @Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.showSpinner = false;
    }, 1500);
    
  }

  move() {
    this.router.navigate(["/FAQs"]);
    console.log("clicked");
  }

  @HostListener("window:scroll", [])

  onWindowScroll() {
    if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
      this.windowScrolled = true;
    } 
    else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) { 
      this.windowScrolled = false;
    }
  } 
  
  scrollToTop1() {
    (function smoothscroll() {

      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop; 
      
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - (currentScroll / 8));
      }

    })();
  }
  openTab = 1;
  toggleTabs($tabNumber: number) {
    this.openTab = $tabNumber;
  }
    scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
